import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useCreateSettlementType, useUpdateSettlementType } from "../../api/settlementTypes";
import { useToast } from "../../components/ToastProvider";
import { SettlementType } from "../../types/dtos";

export function SettlementTypeModal({
  show,
  editing,
  onClose,
}: {
  show: boolean;
  editing: SettlementType | null;
  onClose: () => void;
}) {
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const create = useCreateSettlementType();
  const update = useUpdateSettlementType();
  const toast = useToast();

  useEffect(() => {
    if (show) {
      setName(editing?.name ?? "");
      setError(null);
    }
  }, [show, editing]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return setError("Informe o nome do tipo de baixa.");
    try {
      if (editing) {
        await update.mutateAsync({ id: editing.id, input: { name } });
        toast("Tipo de baixa atualizado.");
      } else {
        await create.mutateAsync(name);
        toast("Tipo de baixa cadastrado.");
      }
      onClose();
    } catch {
      setError("Não foi possível salvar — já existe um tipo de baixa com esse nome?");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show={show} onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>
            {editing ? "Editar tipo de baixa" : "Novo tipo de baixa"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: 700 }}>
            Nome
          </label>
          <input
            className="form-control"
            autoFocus
            placeholder="Ex.: Dinheiro, PIX, Cartão, Transferência…"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {error && (
            <div className="text-danger mt-2" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={create.isPending || update.isPending}>
            Salvar
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
